export const USE_GOOGLE_ANALYTICS = true;
export const USE_GOOGLE_TAGMANAGER = true;
export const USE_GOOGLE_RECAPTCHA = true; // works on FE and BE side.
export const USE_USERCENTRICS = true;
